import ApplicationController from "application_controller.js";

export default class extends ApplicationController {

  debug = false;

  connect() {
    this.log_function("connect");

    this.dispatch("cookie-policy:runIframeManager", { prefix: false });
  }

  disconnect(){
    this.log_function("disconnect");

    this.dispatch("cookie-policy:resetIframeManager", { prefix: false, target: window });
  }
}
